import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import { Field } from "formik";
import InputLabel from "@material-ui/core/InputLabel";

import useStyles from "assets/jss/material-dashboard-react/components/inputStyle";
import TextField from "@material-ui/core/TextField";
import { InputAdornment } from "@material-ui/core";
import ErrorMessage from "@Components/ErrorMessage";
import { useTranslation } from "react-i18next";

const PhoneField = (props) => {
  const { t } = useTranslation();
  const classesInner = useStyles();
  const { label, name, required, errorMessage, ...rest } = props;

  return (
    <Field name={name}>
      {(props) => {
        let { field, meta } = props;
        if (field.value && typeof field.value === "string") {
          if (field.value.substring(0, 2) === "60") {
            field.value = field.value.substring(2);
          }
        }
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classesInner.label, {
                [classesInner.error]:
                  errorMessage || (meta.error && meta.touched),
              })}
            >
              {t(label)}
              {required ? <span style={{ color: "red" }}> *</span> : null}
            </InputLabel>
            <TextField
              // className={clsx(classesInner.root, {
              //   [classes]: classes,
              // })}
              name={name}
              error={Boolean(meta.touched) && Boolean(meta.error)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+60</InputAdornment>
                ),
              }}
              inputProps={{ maxLength: 10 }}
              {...rest}
              {...field}
              fullWidth
              size="small"
            />
            {errorMessage || (meta.error && meta.touched) ? (
              <ErrorMessage
                message={errorMessage ? errorMessage : meta.error}
              />
            ) : null}
          </>
        );
      }}
    </Field>
  );
};

PhoneField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  classes: PropTypes.string,
  name: PropTypes.string,
  field: PropTypes.object,
  meta: PropTypes.object,
  errorMessage: PropTypes.array,
};

export default PhoneField;
